import { FC } from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

const CashIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <G fill={color} clipPath="url(#cash-icon-clip)">
                <Path d="M15.184 12.577c-1.66.402-5.418.382-7.186.978-.789.265-1.932.913-2.696 1.47-.12.09-.29.026-.328-.123-.316-1.263-1.212-4.889-1.711-6.935a.18.18 0 0 0-.26-.123 4 4 0 0 0-.934.57.18.18 0 0 0-.063.187c.221.862 1.63 6.34 2.103 8.172.057.22.31.305.48.162.865-.7 2.04-1.6 3.757-2.11 2.07-.616 5.695-.635 7.255-.953 1.08-.22 1.85-.615 2.292-.964a.19.19 0 0 0 .063-.195c-.063-.24-.14-.498-.215-.777a.2.2 0 0 0-.284-.13c-.543.28-1.238.532-2.273.778z" />
                <Path d="M16.219 3.233a.29.29 0 0 0-.436-.188c-.587.35-1.073.68-1.92.894-2.45.628-5.708.53-7.311.932-1.497.376-2.128.726-2.59 1.082a.31.31 0 0 0-.113.317c.24.965 1.345 5.355 1.737 6.897.05.187.258.278.429.187.587-.323 1.3-.68 2.046-.874 1.667-.447 5.79-.59 7.185-.952 1.263-.33 2.014-.647 2.62-1.036a.29.29 0 0 0 .127-.33c-.493-1.813-1.377-5.18-1.768-6.929zM13.3 9.58c-.669 1.192-2.304 1.509-3.65.712-1.344-.796-1.893-2.408-1.224-3.6.67-1.191 2.305-1.509 3.65-.712s1.894 2.409 1.225 3.6" />
            </G>
            <Defs>
                <ClipPath id="cash-icon-clip">
                    <Path fill="#fff" d="M2 3h16v14H2z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default CashIcon
